// extracted by mini-css-extract-plugin
export default {"NeumorphDiv":"NeumorphDiv_NeumorphDiv__16w-m","NeumorphDiv__NeumorphItem":"NeumorphDiv_NeumorphDiv__NeumorphItem__ILRVa"};